<template>
  <v-dialog
    v-model="modelValue"
    width="unset"
    max-width="500px"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot
        name="activatorButton"
        :on="on"
        :attrs="attrs"
      />
    </template>
    <v-container class="d-flex flex-column main-container">
      <v-row
        no-gutters
        class="d-flex align-center"
      >
        <slot name="icon" />
        <p class="dialog-title pa-0 ma-0">
          {{ title }}
        </p>
      </v-row>

      <div class="mt-4">
        <v-row
          v-if="subtitle"
          no-gutters
          class="subtitle"
        >
          <p class="pa-0 ma-0">
            {{ subtitle }}
          </p>
        </v-row>
      </div>

      <div
        style="overflow-x: hidden"
        class="my-4"
      >
        <v-row no-gutters>
          <slot name="content" />
        </v-row>
      </div>

      <v-col>
        <v-row class="mb-2">
          <slot name="primaryButton" />
        </v-row>
        <v-row>
          <slot name="cancelButton" />
        </v-row>
      </v-col>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseDialogContainer",
  props: {
    title: String,
    subtitle: { type: String, default: null },
    dialogModel: Boolean,
  },
  data: function () {
    return {};
  },
  computed: {
    modelValue: {
      get() {
        return this.dialogModel;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
};
</script>

<style scoped>
.subtitle {
  font-weight: 400; /* Adjust weight as needed */
  font-size: 1em; /* Adjust size as needed */
  color: var(--color-text-muted); /* Optional: Change color if desired */
}
.dialog-title {
  font-weight: 600;
  font-size: 1.2em;
  color: var(--color-text);
}
.main-container {
  background-color: var(--color-surface);
  border-radius: 8px;
  border: 1px solid var(--color-border);
}
</style>
